<template>
  <div>
    <el-select
      v-model="patient"
      :placeholder="$t('text.select')"
      filterable
      popper-class="patient-poper"
      @change="changeSelectedPatient"
      :size="$root.screenWidth >= 550 ? 'medium' : 'mini'"
    >
      <div class="patient-item-wrapper">
        <el-option
          v-for="patient in patients"
          :key="patient.patientId"
          :label="
            patient.alias +
              ' (' +
              (patient.podMac
                ? patient.podMac.substr(-4)
                : $t('text.no_pod_assigned')) +
              ')'
          "
          :disabled="!patient.podMac"
          :value="patient.patientId"
        >
          <div @click="handleClickPatientItem(patient)" class="patient-item">
            <div class="grey-circle mr-5">
              <img src="@/assets/image/user-icon-white.png" />
            </div>
            <div class="name">{{ patient.alias }}</div>
            <div class="desc">
              ({{
                patient.podMac
                  ? patient.podMac.substr(-4)
                  : $t('text.no_pod_assigned')
              }})
            </div>
          </div>
        </el-option>
      </div>
    </el-select>
    <UpdatePatientDeviceAndProucts
      ref="updatePatientDeviceAndProucts"
      :shouldRedirectDashboard="false"
      @success="search()"
    />
  </div>
</template>

<script>
import { patientQuickActions } from '@/const'
import ApiService from '@/services/ApiService.js'
import UpdatePatientDeviceAndProucts from '@/components/patients/quickActions/UpdatePatientDeviceAndProucts.vue'
import _ from 'lodash'
export default {
  data() {
    return {
      patientQuickActions,
      patient: this.$store.state.patient.selectedPatient
        ? this.$store.state.patient.selectedPatient.patientId
        : '',
      patients: this.$store.state.patient.patients,
      operatePatient: '',
      timer: ''
    }
  },
  components: {
    UpdatePatientDeviceAndProucts
  },
  mounted: function() {
    this.search()
    this.timer = setInterval(this.search, 120000)
    this.$hub.$on('patient-updated', this.onPatientUpdated)
    this.$bus.$on('updatePatientDropdown', this.search)
  },
  watch: {
    '$store.state.patient.selectedPatient': function() {
      this.patient = this.$store.state.patient.selectedPatient
        ? this.$store.state.patient.selectedPatient.patientId
        : ''
    },
    '$store.state.filter.dashboardFilter': {
      handler: _.debounce(function() {
        this.search()
      }, 100),
      deep: true
    }
  },
  methods: {
    search() {
      return ApiService.getPatients(
        this.$store.getters[`filter/calculatedFilter`].organisationId,
        this.$store.getters[`filter/calculatedFilter`].flag,
        this.$store.getters[`filter/calculatedFilter`].filterIds
      ).then(response => {
        this.patients = []
        this.patients = response.data.data.map(item => {
          return {
            ...item,
            label: item.alias + ' (' + item.podMac.substr(-4) + ')'
          }
        })
        let patientsWithPod = this.patients.filter(item => item.podMac)

        let patients = patientsWithPod.length ? patientsWithPod : this.patients
        if (this.patient) {
          let selectedPatient
          selectedPatient = this.patients.filter(item => {
            return this.patient === item.patientId
          })
          this.patient = selectedPatient.length
            ? selectedPatient[0]
            : patients[0]
          this.$store.commit(
            'patient/SET_SELECTED_PATIENT',
            selectedPatient.length ? selectedPatient[0] : patients[0]
          )
        } else {
          this.$store.commit('patient/SET_SELECTED_PATIENT', patients[0])
        }
      })
      // .catch(() => {})
    },
    changeSelectedPatient() {
      let selectedPatient = this.patients.filter(
        item => item.patientId === this.patient
      )
      if (selectedPatient.length) {
        this.$store.commit('patient/SET_SELECTED_PATIENT', selectedPatient[0])
      }
    },
    onPatientUpdated(response) {
      let isAdded = true
      this.patients.forEach((item, index) => {
        if (item.patientId === response.patientId) {
          isAdded = false
          this.patients.splice(index, 1, response)
        }
      })
      if (isAdded) {
        this.patients.push(response)
      }
      this.$store.commit('patient/SET_PATIENTS', this.patients)
    },
    handleClickPatientItem(patient) {
      // When patients with no pod assigned is clicked, show the edit patient pop up wizard to allow them to edit/ assign a pod to them.
      if (patient.podMac) return false
      if (!this.$permission('Patients.Edit')) return false
      this.$refs.updatePatientDeviceAndProucts.openDialog(
        this.$t('text.assign_pod'),
        patientQuickActions.assignPod
      )
      this.$nextTick(() => {
        this.$refs.updatePatientDeviceAndProucts.$refs.selectPatient.form.selectedPatient =
          patient.patientId
        this.$refs.updatePatientDeviceAndProucts.activeCard = 1
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown__item::v-deep {
  height: auto;
}
</style>
